<template>
  <div class="d-flex align-items-center">
    <label for="">{{ configs.label }}</label>
    <select class="form-select" @change="onChange($event)">
      <option selected>Mặc định</option>
      <option v-for="option in configs.options" :key="option.key" :value="option.key" >
        {{ option.value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    configs: Object,
  },
  methods: {
    onChange(option = false) {
      this.$emit('selected', option)
    }
  }
};
</script>

<style lang="scss" scoped>
.form-select {
  padding: 2px;
  padding-right: 16px;
  font-size: 14px;
  border: 1px solid #000;
  background-color: transparent;
  border-radius: unset;
  margin: 0 8px;
  width: 100px;
  &:focus {
    border-color: unset;
    box-shadow: unset;
  }
}
</style>
